import { z } from 'zod';
/** Internal producer protocol. Amounts remain exact integer strings; neither
 * these contracts nor the transport supplies a price or an approved policy. */
export const ALLOWANCE_METERS = ['ai.tokens', 'spend.usd.micros'];
export const ALLOWANCE_BODY_LIMIT = 4096;
const uuid = z.string().regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
const quantity = z.object({ meter: z.enum(ALLOWANCE_METERS), units: z.string().regex(/^(0|[1-9][0-9]{0,19})$/) }).strict();
const quantities = z.array(quantity).min(1).max(ALLOWANCE_METERS.length)
    .refine(value => new Set(value.map(entry => entry.meter)).size === value.length);
export const reserveAllowanceRequest = z.object({
    requestKey: z.string().regex(/^[A-Za-z0-9_-]{1,128}$/),
    operation: z.enum(['ai.chat', 'ai.embed']),
    requested: quantities.refine(value => value.every(entry => entry.units !== '0')),
}).strict();
export const settleAllowanceRequest = z.object({ reservationId: uuid, actual: quantities }).strict();
export const reserveAllowanceResponse = z.discriminatedUnion('status', [
    z.object({ status: z.literal('reserved'), reservationId: uuid }).strict(),
    z.object({ status: z.literal('replay'), reservationId: uuid, state: z.enum(['reserved', 'settled']) }).strict(),
    z.object({ status: z.literal('refused'), reason: z.enum(['project_unavailable', 'policy_unavailable', 'allowance_exhausted']) }).strict(),
]);
export const settleAllowanceResponse = z.object({ status: z.enum(['settled', 'replay']), overrun: z.boolean() }).strict();
//# sourceMappingURL=allowances.js.map